import React, {useEffect, useState} from 'react'
import Modal from "../../../Modal";
import AdministracionUsuarioService from "../../../../services/AdministracionUsuarioService";
import {CarritoComprasSeleccionarCuenta} from "../../../../view/carrito/paso_03/CarritoComprasSeleccionarCuenta";
import {MensajeError} from "../../../../view/MensajeError";
import CarritoService from "../../../../services/CarritoService";
import CuentaService from "../../../../services/CuentaService";
import RegistroDominioService from "../../../../services/RegistroDominioService";

export const ModalRenovacionDominio = ({ idDominioCore, nombreDominio, handleOnClose, isOpen, respuestaAccionOk, setIsProcesando, setMensajeProcesando }) => {
    const [camposError, setCamposError] = useState(undefined);
    const [warningCompraInmediata, setWarningCompraInmediata] = useState("Le informamos que si continúa con la compra inmediata, se eliminarán todos los elementos que tenga en el carrito de la compra actual");
    const [templateCuentaPago, setTemplateCuentaPago] = useState(undefined);
    const [estaRenovando, setEstaRenovando] = useState(false);
    const [error, setError] = useState({
        error: false,
        mensaje: "Sin errores"
    });

    const [formasDePago, setFormasDePago] = useState([]);
    const [formaDePagoActual, setFormaDePagoActual] = useState(undefined);
    const [aniosRenovacion, setAniosRenovacion] = useState([1]);
    const [cantAnios, setCantAnios] = useState(1);

    const extensionDesdeNombre = (nombre) => {
        const m = (nombre || '').match(/[.].*/);
        return m ? m[0] : '';
    };

    useEffect(() => {
        CarritoService.obtenerFormasDePago().then(response => {
            if (response !== undefined && response.respuestaOK) {
                setFormasDePago(response.formasDePago);
                setFormaDePagoActual(response.formasDePago[0]); // por defecto
            }
        })
    }, []);

    useEffect(() => {
        obtenerPermisosDominios();
    },[])

    useEffect(() => {
        const ext = extensionDesdeNombre(nombreDominio);
        if (!ext) {
            return;
        }
        RegistroDominioService.obtenerTarifas(ext, 'RENOVACION').then((tarifa) => {
            const anios = (tarifa && tarifa.aniosContratacion && tarifa.aniosContratacion.length > 0)
                ? tarifa.aniosContratacion
                : [1];
            setAniosRenovacion(anios);
            setCantAnios(anios.includes(1) ? 1 : anios[0]);
        });
    }, [nombreDominio, isOpen]);

    const obtenerPermisosDominios = () => {
        // AdministracionUsuarioService.obtenerPermisosDominio(mapPermisosDominio, dominiosSeleccionados, rolSeleccionado, 'editarDatosContacto')
        //     .then(response => {
        //         if (response.codigo === 'OK') {
        //         }
        //     }).finally(() => {
        // })
    }

    const handleOnChangeTemplateCuentaPago = (templateCuenta) => {
        setTemplateCuentaPago(templateCuenta);
    }

    const renovar = async (e) => {
        e.preventDefault();

        if (localStorage.getItem('estaRenovando') === 'true') {
            setError({ error: true, mensaje: "Ya se encuentra en proceso de renovación." });
            return;
        }
        localStorage.setItem('estaRenovando', 'true');

        if (!templateCuentaPago || !formaDePagoActual) {
            setError({ error: true, mensaje: "Debe seleccionar una cuenta de pago" });
            localStorage.setItem('estaRenovando', 'false');
            return;
        }

        setError({ error: false, mensaje: "Sin errores" });

        let cuentaParaUsar = templateCuentaPago;

        // Si es una cuenta nueva (id -1), primero hay que crearla
        if (templateCuentaPago.id === -1) {
            const validacion = validarDatosCuentaPago(templateCuentaPago);
            if (validacion.error) {
                setError(validacion);
                localStorage.setItem('estaRenovando', 'false');
                return;
            }

            try {
                setMensajeProcesando('Creando cuenta de pago...');
                setIsProcesando(true);

                const response = await CuentaService.crearCuentaPago(null, templateCuentaPago, formaDePagoActual);
                if (response.respCodigo !== 'OK') {
                    throw new Error(response.respMensaje);
                }

                cuentaParaUsar = response.templateCuentaPago;

            } catch (err) {
                setError({
                    error: true,
                    mensaje: err.message || "Error al crear cuenta de pago."
                });
                localStorage.setItem('estaRenovando', 'false');
                setIsProcesando(false);
                return;
            }
        }

        // Ya sea cuenta nueva o ya existente, renovamos con cuentaParaUsar
        const renovarDominioDTO = {
            idDominioCore: idDominioCore,
            nombreDominio: nombreDominio,
            compraInmediata: true,
            asociarTemplateCuenta: true,
            cantAnios: Number(cantAnios),
            pagoVentaDTO: {
                medioPago: "ff",
                generaPago: true,
                generaFactura: true
            },
            templateCuentaPagoDTO: cuentaParaUsar
        };

        setMensajeProcesando('Procesando renovación...');
        try {
            const response = await AdministracionUsuarioService.renovarDominio(renovarDominioDTO);
            if (!response.esRespOK) {
                setError({ error: true, mensaje: response.mensaje });
            } else {
                respuestaAccionOk(response.mensaje);
                handleOnClose();
            }
        } catch {
            setError({ error: true, mensaje: "Ha ocurrido un error al renovar dominio." });
        } finally {
            setIsProcesando(false);
            localStorage.setItem('estaRenovando', 'false');
        }
    };

    function validarDatosCuentaPago(templateCuentaPago) {
        let camposConError = [];
        let errorValidacion = {
            error: false,
            mensaje: "Sin errores"
        }
        if (templateCuentaPago.id === undefined || templateCuentaPago.id === -1) {
            if (templateCuentaPago.nombre.trim().length === 1) {
                errorValidacion = {
                    error: true,
                    mensaje: "El nombre ingresado no es v\u00E1lido"
                };
            }

            if (templateCuentaPago.cuenta.idPais === undefined) {
                errorValidacion = {
                    error: true,
                    mensaje: "El pa\u00EDs seleccionado no es v\u00E1lido"
                };
            }

            if (templateCuentaPago.cuenta.idTipoDocumento === undefined) {
                errorValidacion = {
                    error: true,
                    mensaje: "El tipo de documento seleccionado no es v\u00E1lido"
                };
            }

            if (chequearVacio(templateCuentaPago.nombre.trim())) {
                errorValidacion = {
                    error: true,
                    mensaje: "Debe completar todos los campos obligatorios"
                };
                camposConError.push("nombre");
            }

            if (chequearVacio(templateCuentaPago.cuenta.cuenta.trim())) {
                errorValidacion = {
                    error: true,
                    mensaje: "Debe completar todos los campos obligatorios"
                };
                camposConError.push("cuenta");
            }

            if (chequearVacio(templateCuentaPago.cuenta.nroDocumento.trim())) {
                errorValidacion = {
                    error: true,
                    mensaje: "Debe completar todos los campos obligatorios"
                };
                camposConError.push("nroDocumento");
            }
        }
        setCamposError(camposConError);
        return errorValidacion;
    }

    const chequearVacio = (texto) => {
        return texto.length === 0;
    }

    return <>

        <Modal
            idDivModal="idModalRenovar"
            handleClose={handleOnClose} isOpen={isOpen} closeOnClickOutside={false}>

            <fieldset style={{width: '600px'}}>

                <legend>Renovaci&oacute;n inmediata de dominio</legend>

                {error !== undefined && error.error && <MensajeError mensajeError={error.mensaje}/>}

                <form id="id-form-renovar-dominio" autoComplete="off">
                    <div className="form-item">
                        <label htmlFor="id-anios-renovacion-inmediata">Años renovaci&oacute;n</label>
                        <select id="id-anios-renovacion-inmediata" value={cantAnios}
                                onChange={(e) => setCantAnios(Number(e.target.value))}>
                            {aniosRenovacion.map((anio) => (
                                <option key={anio} value={anio}>{anio} {anio > 1 ? 'años' : 'año'}</option>
                            ))}
                        </select>
                    </div>

                    <p>
                        <label>{ "Seleccionar cuenta de telefonía fija o datos" }</label>
                    </p>

                    <div className="message-box" id="register-warning">
                        <h3> { warningCompraInmediata } </h3>
                    </div>

                    <fieldset>
                        <legend>Datos de la cuenta de Antel de telefonía fija o datos</legend>
                        <div id="div-fieldset-nueva-cuenta">
                            <CarritoComprasSeleccionarCuenta ocultarMsjCuentaPago={true} onChangeTemplateCuentaPago={handleOnChangeTemplateCuentaPago}
                                 camposConError={camposError}
                                 setError={setError}
                            />
                        </div>
                    </fieldset>

                    <div className="right">
                        <button className={"btn"} onClick={renovar}>Renovar</button>
                    </div>

                </form>

            </fieldset>

        </Modal>
    </>
}
